import { render, staticRenderFns } from "./Custas.vue?vue&type=template&id=613c2b5a&"
import script from "./Custas.vue?vue&type=script&lang=js&"
export * from "./Custas.vue?vue&type=script&lang=js&"
import style0 from "./Custas.vue?vue&type=style&index=0&id=613c2b5a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports